import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/style/index.scss'
import App from './App'
import router from './router'
import './permission'
import store from './store'
import axiosInit from './axios-init'
import tool from './tool'
import echarts from 'echarts'
import md5 from 'js-md5'


window.axios = axiosInit()
Vue.prototype.$http = window.axios
Vue.prototype.$tool = tool
Vue.prototype.$echarts = echarts;
Vue.prototype.$md5 = md5 // md5 加密
Vue.use(ElementUI, {
  size: 'small'
})

// 跳转后返回顶部
router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
})
//或者
router.beforeEach((to, from, next) => {    
// chrome
document.body.scrollTop = 0
// firefox
document.documentElement.scrollTop = 0
// safari
window.pageYOffset = 0
next()
})


Vue.config.productionTip = false
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})





// WEBPACK FOOTER //
// ./src/main.js